import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { SmartTeamsAppUser } from '@nsc/smartteams-shared/db/SmartTeamsAppUser.js';
import { SmartTeamsCustomer } from '@nsc/smartteams-shared/db/SmartTeamsCustomer.js';

/**
 * Resolve a Customer-userGroup app user's `customerIds` to their underlying ServiceNow
 * client sys_ids. Returns an empty array when the user has no linked customers, or when
 * none of the linked customers carry a `serviceNowClientId` yet.
 *
 * Used by ticket-queries / _assignee-guard / geolocation-queries / ticket-review-queries
 * to scope ticket visibility by customer membership.
 */
export async function resolveCustomerSysIds(appUser: SmartTeamsAppUser): Promise<string[]> {
  const ids = appUser.customerIds ?? [];
  if (ids.length === 0) return [];
  const col = await getRawCollection<SmartTeamsCustomer>(SmartTeamsCustomer._collectionName);
  const customers = await col.find({ _id: { $in: ids } }, { projection: { serviceNowClientId: 1 } }).toArray();
  return customers.map(c => c.serviceNowClientId).filter((s): s is string => !!s);
}
